import React, { useEffect, useState } from "react";
import { ShieldCheck, HelpingHand, Sun, PhoneCall, AlertTriangle } from "lucide-react";
import { api } from "../api";
import { timeAgo } from "../lib/util";

const META = {
  safe:           { color: "bg-sage-500", label: "I am safe", Icon: ShieldCheck },
  help:           { color: "bg-brick-500", label: "SOS: needed help", Icon: AlertTriangle },
  check_in_okay:  { color: "bg-terracotta-500", label: "Daily check-in · Okay", Icon: Sun },
  check_in_callme:{ color: "bg-terracotta-500", label: "Asked to be called", Icon: PhoneCall },
  check_in_help:  { color: "bg-brick-500", label: "Check-in · Need help", Icon: HelpingHand },
};

export default function Activity() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/events?limit=80");
        setItems(data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="px-6 pt-4 pb-4" data-testid="activity-screen">
      <p className="text-[12px] tracking-[0.16em] uppercase text-ink-500">Recent moments</p>
      <h1 className="font-display text-[34px] leading-[1.05] text-ink-900 mt-1 tracking-tight">Your timeline</h1>
      <p className="text-sm text-ink-500 mt-1">A quiet record of every ping, check-in, and SOS.</p>

      <div className="mt-6 relative">
        <div className="absolute left-[19px] top-2 bottom-2 w-px bg-sand-200" />
        {loading && <p className="text-sm text-ink-500" data-testid="activity-loading">Loading…</p>}
        {!loading && items.length === 0 && (
          <div className="rounded-3xl border-2 border-dashed border-sand-200 p-6 text-center mt-2" data-testid="activity-empty">
            <p className="font-display text-xl text-ink-900">Nothing yet.</p>
            <p className="text-sm text-ink-500 mt-1">Tap “I am Safe” on the Home tab to make your first ping.</p>
          </div>
        )}
        <div className="space-y-3">
          {items.map((e) => {
            const m = META[e.type] || META.safe;
            const Icon = m.Icon;
            return (
              <div key={e.id} className="relative pl-12" data-testid={`event-${e.id}`}>
                <div className={`absolute left-[8px] top-3 h-6 w-6 rounded-full text-white flex items-center justify-center ring-4 ring-sand-50 ${m.color}`}>
                  <Icon size={12} strokeWidth={2.6}/>
                </div>
                <div className="bg-white rounded-2xl border border-sand-200 p-4">
                  <div className="flex items-center justify-between">
                    <p className="font-semibold text-ink-900 text-[15px]">{m.label}</p>
                    <p className="text-[11px] text-ink-500">{timeAgo(e.created_at)}</p>
                  </div>
                  {e.message && <p className="text-[13px] text-ink-700 mt-1">{e.message}</p>}
                  {(e.lat && e.lng) && (
                    <p className="text-[11px] text-ink-500 mt-2">
                      📍 {e.lat.toFixed(3)}, {e.lng.toFixed(3)}
                      {typeof e.battery === "number" && <> · 🔋 {e.battery}%</>}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
